module.exports = __webpack_public_path__ + "img/card1_bg_new.6ec9aa43.png";